import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Input, Spin } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import HelperModal from './HelperModal';
import { DEFAULT_PLUGIN_THUMBNAIL, PLUGIN_NEW_EXCHANGE, INSTALL_PLUGIN, BANXA_PLUGIN, DEVELOP_PLUGIN } from '../../config/media';
import { getActivationDetail, getPluginData } from '../../common/fetch';
import { pluginData, ActivatedPluginData } from '../../actions/PluginAction';
import { HeaderFooterLinks, RenderPlugin } from './Utils';
import { PluginAppWrapper } from './style';

const PluginApps = (props) => {

	const [pluginsData, setPluginsData] = useState([]);
	const [searchPlugin, setSearchPlugin] = useState('');
	const [isSearchTerm, setIsSearchTerm] = useState(false);
	const [isActivePlugin, setIsActivePlugin] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isInstall, setIsInstall] = useState(false);
	const [categorizedPlugins, setCategorizedPlugins] = useState({
		communications: [],
		onOffRamping: [],
		knowYourCustomer: [],
		referralsAndRewards: [],
		publicity: []
	})

	const { UpdatePluginName, ActivatedPlugin, exchange, pluginData } = props;
	const topThreePlugins = ['announcements', 'bank'];

	const pluginDetails = [
		{
			id: 'communications',
			heading: 'Communications',
			content: 'Plugins to help you communicate to your user base. Chat, announcement, and plugins to enable SMS notifications and more',
			pluginCategory: 'communications',
			imgSrc: null,
		},
		{
			id: 'onOffRamping',
			heading: 'On/Off ramping',
			pluginCategory: 'onOffRamping',
			imgSrc: BANXA_PLUGIN,
		},
		{
			id: 'knowYourCustomer',
			heading: 'Know your customer',
			content: 'KYC and AML system to help you streamline your user verification processes.',
			pluginCategory: 'knowYourCustomer',
			imgSrc: null,
		},
		{
			id: 'referralsAndRewards',
			heading: 'Referrals and Rewards',
			content: 'Digital assets distribution and referral mechanisms for rewarding certain user groups.',
			pluginCategory: 'referralsAndRewards',
			imgSrc: DEVELOP_PLUGIN,
		},
		{
			id: 'publicity',
			heading: 'Publicity',
			content: 'PR related plugins to boost the public visibility to your exchange platform using CoinMarketCap and others.',
			pluginCategory: 'publicity',
			imgSrc: null,
		},
	];

	useEffect(() => {
		setIsLoading(true);
		getPlugins();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const getPlugins = async () => {
		const result = await getActivationDetail();
		ActivatedPlugin(result.data);
		setIsActivePlugin(result.data)
		const res = await getPluginData();
		setIsLoading(false);
		if (res && res.data && res.data.data) {
			setPluginsData(res.data.data);
		}
		
		res && res.data && res.data.data.forEach(val => {
			const category = val.category;
			setCategorizedPlugins(prev => {
				const updatedPlugins = { ...prev };
				if (category === 'communication') {
					updatedPlugins.communications = [...prev.communications, val.name];
				} else if (category === 'fiat') {
					updatedPlugins.onOffRamping = [...prev.onOffRamping, val.name];
				} else if (category === 'kyc') {
					updatedPlugins.knowYourCustomer = [...prev.knowYourCustomer, val.name];
				} else if (category === 'rewards') {
					updatedPlugins.referralsAndRewards = [...prev.referralsAndRewards, val.name];
				} else if (category === 'publicity') {
					updatedPlugins.publicity = [...prev.publicity, val.name];
				}
				return updatedPlugins;
			});
		});
	};

	const activeData = useMemo(() => {
		let active = [];
		isActivePlugin.forEach((val) => {
			let data = pluginsData.filter((item) => {
				return val.name === item.name
			})
			active.push([...data])
		})
		return active
	}, [isActivePlugin, pluginsData])

	const data = activeData.flat()

	const searchPluginDetail = useMemo(() => {
		const filteredData = pluginsData && pluginsData.filter((value) => value.name.includes(searchPlugin));
		if (!filteredData.length && !searchPlugin) {
			return pluginsData;
		}
		return filteredData;
	}, [searchPlugin, pluginsData])

	const handleOpenPlugin = async (plugin) => {
		UpdatePluginName(plugin);
		props.history.push('/plugindetails');
	};

	const renderList = (types) => {
		const renderType = (type) => {
			const typeMappings = {
				'topPlugins': topThreePlugins,
				'communications': categorizedPlugins.communications,
				'onOffRamping': categorizedPlugins.onOffRamping,
				'knowYourCustomer': categorizedPlugins.knowYourCustomer,
				'referralsAndRewards': categorizedPlugins.referralsAndRewards,
				'publicity': categorizedPlugins.publicity
			};
			return type && (typeMappings[type] || []);
		};

		return searchPluginDetail.map((item, index) => {
			const typeList = renderType(types);
			if (types && typeList.includes(item.name)) {
				return (
					<div
						key={index}
						className={'plugin-list-item removing-item d-flex align-items-center mt-3'
						}
						onClick={() => handleOpenPlugin(item)}
					>
						<div className="d-flex justify-content-center plugin-card-wrapper">
							<div className='icon-wrapper'>
								<img
									src={item.icon ? item.icon : DEFAULT_PLUGIN_THUMBNAIL}
									alt={`plugin-${index}`}
									className="plugin-list-icon"
								/>
							</div>
							<div className="description-content">
								<p className="bold text-white plugin-list-title">{item.name}</p>
								<p className="text-white plugin-list-bio">{item.bio}</p>
								{item.enabled ? (
									<div className="plugin-list-type">
										<CheckOutlined /> <div>Currently installed</div>
									</div>
								) : (
									<p className="plugin-list-font">
										{item.payment_type === 'free' || item.price === 0
											? 'Free'
											: `$ ${item.price}`}
									</p>
								)}
								{(data.some((v) => v.name === item.name) || (item.price === 0)) &&
									<p>✓ Activated and ready to install</p>
								}
							</div>
						</div>
					</div>
				);
			}
			return null;
		});
	};

	const onHandleSearch = (e) => {
		if (e.target.value) {
			setIsSearchTerm(true);
		}
		setSearchPlugin(e.target.value);
		setIsSearchTerm(!!e.target.value);
	};

	const onHandleScroll = (type) => {
		const element = document.getElementById(type);
		element.scrollIntoView();
	}

	const scrollHeaders = [{ title: "Communications", id: 'communications' }, { title: "Fiat On/Off ramping", id: 'onOffRamping' }, { title: "KYC/AML", id: 'knowYourCustomer' }, { title: "Referral and rewards", id: 'referralsAndRewards' }, { title: "Publicity", id: 'publicity' }]

	return (
		<PluginAppWrapper>
			<div className='pulgin-apps-wrapper'>
				<div className="d-flex justify-content-between header-wrapper">
					<div className="d-flex title-wrapper">
						<div>
							<img
								src={PLUGIN_NEW_EXCHANGE}
								alt="Plugin"
								className="plugin-icon"
							/>
						</div>
						<div className="title-content-wrapper">
							<p className="text-white sub-title-font">EXCHANGE STORE</p>
							<p className="plugin-title">Explore powerful plugin apps</p>
							<p className="text-white sub-title-font">Efficiently boost the functionality and user experience of your exchange</p>
							<p className="text-white sub-title-font d-flex title-content">Buy and activate premium plugins below and install them directly on your <p className='exchange-link-label cursor-pointer ml-3' onClick={() => setIsInstall(true)}>Live exchange</p></p>
							<div className='d-flex text-white scrool-hearder-wrapper'>
								{scrollHeaders.map((val) => {
									return (<div className='d-flex'>
										<p className='ml-3 text-white cursor-pointer text-decoration-underline' onClick={() => onHandleScroll(val.id)}>{val.title}</p>
										<p className='scrool-hearder-icon'>{val.id !== 'publicity' ? '◦' : ''}</p>
									</div>)
								})}
							</div>
						</div>
					</div>
					<div className='d-flex header-links'>
						<HeaderFooterLinks linkText={'ABOUT PLUGINS'} path={'use-plugins'} className='header' />
						<HeaderFooterLinks linkText={'DEVELOPING PLUGINS'} path={'develop-plugins'} className='header' />
						<HeaderFooterLinks linkText={'INSTALLING PLUGINS'} path={'installing-plugin'} className='header' />
					</div>
				</div>
				<h1 className='bold app-title'>Top 3 exchange plugin apps</h1>
				<div className='d-flex sub-title-content-wrapper'>
					<p className='search-label'>Search:</p>
					<Input onChange={(e) => onHandleSearch(e)} className='filter-content' placeholder="Input & search an app keyword"></Input>
				</div>
				<Spin spinning={isLoading}>
					<div>
						{searchPluginDetail.length ? (
							<div>
								<RenderPlugin
									renderList={renderList}
									pluginCategory={'topPlugins'}
									imgSrc={INSTALL_PLUGIN}
								/>
								{pluginDetails.map((val) => {
									return (
										<RenderPlugin
											id={val.id && val.id}
											heading={val.heading && val.heading}
											content={val.content && val.content}
											renderList={renderList}
											pluginCategory={val.pluginCategory && val.pluginCategory}
											imgSrc={val.imgSrc && val.imgSrc}
										/>
									)
								})}
								<div className="plugin-divider"></div>
								<div className='d-flex footer-links-wrapper'>
									<div>
										<p className='text-white'>DEVELOPMENT</p>
										<HeaderFooterLinks linkText={'RUN DEV MODE'} path={'run-dev-mode'} className='footer' />
										<HeaderFooterLinks linkText={'BANK INTEGRATION'} path={'bank-integration'} className='footer' />
										<HeaderFooterLinks linkText={'DEVELOPING PLUGINS'} path={'develop-plugins'} className='footer' />
									</div>
									<div className='about-wrapper'>
										<p className='text-white'>ABOUT</p>
										<HeaderFooterLinks linkText={'ABOUT PLUGINS'} path={'use-plugins'} className='footer' />
										<HeaderFooterLinks linkText={'INSTALLING PLUGINS'} path={'installing-plugin'} className='footer' />
									</div>
									<div className='blog-wrapper'>
										<p className='text-white'>BLOG</p>
										<HeaderFooterLinks linkText={'PLUGIN BLOG POST'} path={'bank-integration'} className='footer' />
									</div>
								</div>
							</div>
						) : (
							<div className="installed-plugin">
								{isSearchTerm ? (
									<p className='plugin-content'>Can't find any plugin apps by that search term.</p>
								) : (
									!isLoading && <p className='plugin-content'>No plugin apps found</p>
								)}
							</div>
						)}
					</div>
				</Spin>
			</div>
			{isInstall && <HelperModal isVisible={isInstall} exchange={exchange} selectedPlugin={pluginData} setIsInstall={setIsInstall} />}
		</PluginAppWrapper>
	)
}

const mapStateToProps = (state) => ({
	exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
	pluginData: state.plugin.pluginData,
});

const mapDispatchToProps = (dispatch) => ({
	UpdatePluginName: bindActionCreators(pluginData.pluginData, dispatch),
	ActivatedPlugin: bindActionCreators(ActivatedPluginData.activatedPlugin, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PluginApps);